import { ConfigurationService } from './../../services/configuration/configuration.service';
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { resolve } from 'url';
import { Variables } from 'src/app/Models/variables';

@Component({
  selector: 'app-in-queue-by-status',
  templateUrl: './in-queue-by-status.component.html',
  styleUrls: ['./in-queue-by-status.component.css']
})
export class InQueueByStatusComponent implements OnInit {

  data: any;
  data2: any;
  configs1 = [];
  conf1: any;

  range: any;
  start: any;
  end: any;

  show = false;
  load = false;
  options: { title: { display: boolean; text: any; fontSize: number; }; legend: { position: string; }; };
  confid: number;
  options2: { title: { display: boolean; text: string; fontSize: number; }; legend: { position: string; }; };

  allcount = 0;
  isadm = false;

  constructor(
    private analytics: AnalyticsService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private configService: ConfigurationService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private notificationSvc: NotificationService
  ) {
      this.translate.addLangs(['English', 'French']);
      this.translate.setDefaultLang('English');

      let browserLang = this.translate.getBrowserLang();

      const pass = 'ranitessarldev2019';
      const lang = cookieService.get('goepla-portal-language');
      if (lang.trim() !== '') {
        const declang = CryptoJS.AES.decrypt(lang, pass).toString(CryptoJS.enc.Utf8);
        const lg = declang;
        browserLang = lg;
        localStorage.setItem('language', lg);
      }

      if (localStorage.getItem('language') !== null) {
        browserLang = localStorage.getItem('language');
      }
      this.translate.use(browserLang.match(/English|French/) ? browserLang : 'English');

      if (localStorage.getItem('filter-start') !== null && localStorage.getItem('filter-end') !== null) {
        const st = localStorage.getItem('filter-start');
        const ed = localStorage.getItem('filter-end');
        this.range = [new Date(st), new Date(ed)];
      }

      if (localStorage.getItem('filter-config') !== null) {
        this.confid = +localStorage.getItem('filter-config');
      }

    // tslint:disable-next-line: deprecation
      translate.get('GENERAL.ALL').subscribe((trans) => {
        const conf: any = [];
        conf.configurationId = 0;
        conf.configurationName = trans;
        this.configs1.push({ label: trans, value: conf });
        if (this.confid === 0) {
          this.conf1 = conf;
        }
      });

      const v = new Variables();
      const p = localStorage.getItem('ups');
      if (p == null) {
        this.isadm = false;
      }

      const pr = CryptoJS.AES.decrypt(p, v.pass).toString(CryptoJS.enc.Utf8);
      const perm = JSON.parse(pr);
      if (perm.includes('NTM.Administration.Full')) {
            this.isadm = true;
      }

      this.getConfigurations();
 }

 getConfigurations() {
  this.load = true;
  // tslint:disable-next-line: deprecation
  this.configService.getConfigurations('T').subscribe((res) => {
    if (res != null) {
      const v = new Variables();
      const gis = localStorage.getItem('gi');
      const gs = CryptoJS.AES.decrypt(gis, v.pass).toString(CryptoJS.enc.Utf8);
      const gids = JSON.parse(gs);

      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < res.length; i++) {
        if (res[i].typeRoleGroups !== null && res[i].typeRoleGroups.length > 0) {
          let show = false;
          for (const val of res[i].typeRoleGroups) {
            if (val.typeRoleGroup.roleName === 'Analytics' && gids.includes(val.typeRoleGroup.groupId)) {
              show = true;
            }
          }

          if (this.isadm === true) {
            show = true;
          }

          if (show === false) {
            continue;
          }
        } else {
          if (this.isadm === true) {
          } else {
            continue;
          }
        }
        this.configs1.push({ label: res[i].configurationName, value: res[i] });
        if (this.confid >= 0) {
          if (res[i].configurationId === this.confid) {
            this.conf1 = res[i];
          }
        }
      }
    }
    this.load = false;
  });
  }

  getAnalytics() {
    if (this.configs1 === undefined || this.configs1 === null || this.configs1.length === 1) {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.NODATAAVAILABLE').subscribe((resp: string) => {
        this.notificationSvc.info('', resp, 2000);
        });
      return;
    }
    let tids = '';
    if (this.conf1.configurationId === 0) {
      if (this.allcount + 1 !== this.configs1.length) {
        for (const val of this.configs1) {
          if (val.value.configurationId !== 0) {
            tids += val.value.configurationId + ',';
          }
        }
      }
    }
    if (tids === '') {
      tids = ' ';
    }
    let open = '';
    let assigned = '';
    let started = '';
    let tsks = '';
    let others = '';
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.OPEN').subscribe((trans) => {
      open = trans;
    });
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.ASSIGNED').subscribe((trans) => {
      assigned = trans;
    });
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.STARTED').subscribe((trans) => {
      started = trans;
    });
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.TASKS').subscribe((trans) => {
      tsks = trans;
    });
    // tslint:disable-next-line: deprecation
    this.translate.get('GENERAL.OTHERS').subscribe((trans) => {
      others = trans;
    });
    this.data = [];
    this.show = false;
    this.load = true;
    this.analytics.getAnalyticsGeneric(this.conf1.configurationId, 'T', this.start, this.end,
    // tslint:disable-next-line: deprecation
                               0, 'taskoverviewinqueuebystatus', ' ', tids).subscribe((res) => {
      if (res[0].value2 === 0 && res[1].value2 === 0 && res[2].value2 === 0) {
        this.show = false;
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.NODATAAVAILABLE').subscribe((resp: string) => {
          this.notificationSvc.info('', resp, 2000);
          });
      } else {
        let total = 0;
        let opn = 0;
        let asg = 0;
        let stt = 0;
        let count = 0;
        for (const val of res) {
          const dt = [];
          const dt2 = [];
          if (val.value1 === 'OPEN') {
            opn = val.value2;
            total += val.value2;
          }
          if (val.value1 === 'ASSIGNED') {
            asg = val.value2;
            total += val.value2;
          }
          if (val.value1 === 'STARTED') {
            stt = val.value2;
            total += val.value2;
          }
          count += 1;
          if (count === 3) {
            const o = Math.round((((opn / total) * 100) + Number.EPSILON) * 100) / 100;
            const a = Math.round((((asg / total) * 100) + Number.EPSILON) * 100) / 100;
            const s = Math.round((((stt / total) * 100) + Number.EPSILON) * 100) / 100;
            dt.push(opn);
            dt.push(asg);
            dt.push(stt);
            dt.push(0);

            dt2.push(o);
            dt2.push(a);
            dt2.push(s);
            dt2.push(0);
            this.data = {
              labels: [open, assigned, started, others],
              datasets: [
                  {
                      data: dt2,
                      backgroundColor: [
                          'LightGray',
                          'Yellow',
                          'LightBlue'
                      ],
                      hoverBackgroundColor: [
                        'LightGray',
                        'Yellow',
                        'LightBlue'
                      ]
                  }]
              };
            this.data2 = {
              labels: [open, assigned, started, others],
              datasets: [
                  {
                      label: tsks,
                      backgroundColor: '#42A5F5',
                      borderColor: '#1E88E5',
                      data: dt
                  }
              ]
            };
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.INQUEUEBYSTATUS').subscribe((trans) => {
              this.options = {
                title: {
                    display: true,
                    text: trans,
                    fontSize: 16
                },
                legend: {
                    position: 'top'
                }
              };
            });
            // tslint:disable-next-line: deprecation
            this.translate.get('GENERAL.INQUEUEBYSTATUS').subscribe((trans) => {
              this.options2 = {
                title: {
                    display: true,
                    text: trans + '(%)',
                    fontSize: 16
                },
                legend: {
                    position: 'top'
                }
              };
            });
            this.show = true;
          }
        }
      }
      this.load = false;
    }, err => this.handleError(err));
  }

  ok() {
    this.data = [];
    this.data2 = [];
    if (this.range === undefined || this.range === null) {
      // tslint:disable-next-line: deprecation
      this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
        this.confirm(res);
      });
      return;
    } else {
      if (this.range[0] !== undefined && this.range[0] !== null) {
        this.start = this.range[0].toDateString();
        const a = this.range[0].toDateString();
        const b = new Date(a);
        const c = new Date(b.getFullYear(), b.getMonth(), b.getDate());
        this.start = c.toDateString();
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
          this.confirm(res);
        });
        return;
      }
      if (this.range[1] !== undefined && this.range[1] !== null) {
        this.end = this.range[1].toDateString();
        const a = this.range[1].toDateString();
        const b = new Date(a);
        const c = new Date(b.getFullYear(), b.getMonth(), b.getDate());
        this.end = c.toDateString();
      } else {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.SELECTRANGE').subscribe((res) => {
          this.confirm(res);
        });
        return;
      }

      if (this.conf1 === undefined || this.conf1 === null) {
        // tslint:disable-next-line: deprecation
        this.translate.get('GENERAL.SELECTCONFIGURATION').subscribe((res) => {
          this.confirm(res);
        });
        return;
      }
      localStorage.setItem('filter-start', this.start);
      localStorage.setItem('filter-end', this.end);
      localStorage.setItem('filter-config', this.conf1.configurationId);
      this.getAnalytics();
    }
   }

  ngOnInit() {
  }

  confirm(msg) {
    this.confirmationService.confirm({
        message: msg,
        accept: () => {
            // Actual logic to perform a confirmation
        }
    });
  }

  showInfo() {
    this.messageService.add({severity: 'info', summary: 'Info Message', detail: 'PrimeNG rocks'});
  }

  handleError(err) {
    this.load = false;
    console.log(err);
  }

  setDate() {
    const d = new Date();
    const d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1);
    const d2 = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);

    this.range = [d1, d2];
  }

}
